import {
  CheckCircle,
  Clock,
  XCircle,
  AlertTriangle,
  Truck,
  CreditCard,
} from "lucide-react";
import { useEffect, useState } from "react";

// Utility function for mapping status to bootstrap classes
export const mapStatusToBootstrap = (status) => {
  switch (status?.toLowerCase()) {
    case "completed":
      return "badge bg-success-subtle text-success";
    case "in-progress":
      return "badge text-primary";
    case "accepted":
      return "badge text-info";
    case "cancelled":
      return "badge bg-danger-subtle text-danger";
    case "created":
      return "badge text-warning";
    default:
      return "badge bg-secondary-subtle text-secondary";
  }
};

export const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "delivered":
      case "completed":
        return <CheckCircle size={14} />;
      case "processing":
      case "created":
        return <Clock size={14} />;
      case "shipped":
        return <Truck size={14} />;
      case "cancelled":
      case "failed":
        return <XCircle size={14} />;
      case "pending":
        return <AlertTriangle size={14} />;
      case "ready":
        return <CreditCard size={14} />;
      default:
        return <Clock size={14} />;
    }
  };

// Other utility functions stay the same
export const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(amount);

export const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatDateTime = (date) => {
  if (!date) return "N/A";

  const d = new Date(date);

  if (isNaN(d.getTime())) return "N/A";

  return d.toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};


